import './contentContainer.css';
import React from 'react';
import QuickAccessTables from './QuickAccessTables';
import Scrollbars from 'react-custom-scrollbars-2';
import UserTable from './TablesList/userTable';
import { useTypedSelector } from '../../hooks/useTypeSelector';
import DashboardTable from './TablesList/dashboardTable';
import { useDispatch } from 'react-redux';
import { setTab } from '../../redux/actions/sideBarAction';
import TopicTable from './TablesList/TopicTable';
import SignTopicTable from './TablesList/SignupTopicTables/SignupTopicTableWithReferral';
import NoReferralSignTopicTable from './TablesList/SignupTopicTables/NoReferralSignupTopicTable';
import UninstallTable from './TablesList/UninstallsTable/uninstallTable';
import AggregatedUninstalls from './TablesList/UninstallsTable/aggregatedUninstallTable';
import ReferredExtensionsTable from './TablesList/ReferredExtensionTables/ReferredExtensionTableWithReferralCode';
import ReferredExtensionsTableNoReferral from './TablesList/ReferredExtensionTables/NoReferralCodeReferredExtensionTable';

const DocumentsContainer = () => {
	const { selectedDocumentTable, selectedSubDocumentTable } = useTypedSelector(
		(state) => state.tablesQuickAccess
	);

	const dispatch = useDispatch();
	dispatch(setTab('documents'));

	return (
		<div className="content-container">
			<Scrollbars autoHide>
				<div className="flex flex-col md:flex-row">
					<div className="w-40 mx-auto">
						<QuickAccessTables />
					</div>
					<div className="content-list w-full">
						{(() => {
							switch (selectedDocumentTable) {
								case 'Users':
									switch (selectedSubDocumentTable) {
										case 'All':
											return <UserTable />;
										case 'Active':
											return <UserTable isActive={true} />;
										case 'Premium':
											return <UserTable isPremium={true} />;
										case 'Not active':
											return <UserTable isActive={false} />;
										case 'Uninstalls':
											return <UninstallTable />;
										case 'Ag Uninstalls':
											return <AggregatedUninstalls />;
										default:
											return <UserTable />;
									}
								case 'Topics':
									switch (selectedSubDocumentTable) {
										case 'All':
											return <TopicTable />;
										case 'Accepted':
											return <TopicTable reviewStatus="accepted" />;
										case 'Featured':
											return <TopicTable reviewStatus="featured" />;
										case 'Pending':
											return <TopicTable reviewStatus="pending" />;
										case 'Addit review':
											return <TopicTable reviewStatus="additional review" />;
										case 'Rejected':
											return <TopicTable reviewStatus="rejected" />;
										default:
											return <TopicTable />;
									}
								case 'Dashboards':
									switch (selectedSubDocumentTable) {
										case 'All':
											return <DashboardTable />;
										case 'Default':
											return <DashboardTable />;
										case 'Non Default':
											return <DashboardTable />;
										default:
											return <DashboardTable />;
									}
								case 'Ref topics':
									switch (selectedSubDocumentTable) {
										case 'With Referral':
											return <SignTopicTable />;
										case 'No Referral':
											return <NoReferralSignTopicTable />;
										default:
											return <SignTopicTable />;
									}
								case 'Ref extensions':
									switch (selectedSubDocumentTable) {
										case 'With Referral':
											return <ReferredExtensionsTable />;
										case 'No Referral':
											return <ReferredExtensionsTableNoReferral />;
										default:
											return <SignTopicTable />;
									}
								default:
									return <UserTable />;
							}
						})()}
					</div>
				</div>
			</Scrollbars>
		</div>
	);
};

export default DocumentsContainer;
